export default __webpack_public_path__ + "static/media/login_bg.ed461a5e.svg";